var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotHappyH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 103,
    viewBox: "0 0 104 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_502_6035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 88.4296C74.3675 88.4296 92.5 70.2971 92.5 47.9296C92.5 25.562 74.3675 7.42957 52 7.42957C29.6325 7.42957 11.5 25.562 11.5 47.9296C11.5 70.2971 29.6325 88.4296 52 88.4296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 83.3418C71.5576 83.3418 87.4122 67.4872 87.4122 47.9295C87.4122 28.3719 71.5576 12.5173 52 12.5173C32.4424 12.5173 16.5878 28.3719 16.5878 47.9295C16.5878 67.4872 32.4424 83.3418 52 83.3418Z",
    fill: "url(#paint0_linear_502_6035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8612 48.5907C59.8612 48.5907 60.7429 52.0438 65.0776 52.0438C69.1918 52.0438 70.2939 48.5907 70.2939 48.5907",
    stroke: "black",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7796 48.5907C33.7796 48.5907 34.6612 52.0438 38.9959 52.0438C43.1102 52.0438 44.2122 48.5907 44.2122 48.5907",
    stroke: "black",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2857 67.8397C44.2857 67.8397 50.751 62.4029 59.7143 67.8397",
    stroke: "#5B0600",
    strokeWidth: 3.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8286 11.6357C27.8286 11.6357 34.5143 21.9214 36.4245 27.3581C38.2612 32.6479 37.0123 38.452 32.0163 41.0234C27.0204 43.5948 20.9225 41.6112 18.3511 36.6152C16.8082 33.603 17.1755 30.2969 18.3511 27.3581C21.1429 20.3051 26.947 11.6357 26.947 11.6357C27.0939 11.3418 27.3878 11.2683 27.6817 11.4153C27.6817 11.4153 27.8286 11.5622 27.8286 11.6357Z",
    fill: "url(#paint1_linear_502_6035)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_502_6035",
    x: -3.8,
    y: -4.8582,
    width: 111.6,
    height: 111.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_6035"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_6035",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_6035",
    x1: 21.3439,
    y1: 65.6166,
    x2: 82.72,
    y2: 30.1811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198685,
    stopColor: "#FFBA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5514,
    stopColor: "#FFCE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_6035",
    x1: 27.2552,
    y1: 42.1214,
    x2: 27.2552,
    y2: 11.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7EB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotHappyH);
export default __webpack_public_path__ + "static/media/not-happy-h.817e7002eacc59b36e668f24743e3cfd.svg";
export { ForwardRef as ReactComponent };